

import { Component, Vue } from "vue-property-decorator"
import { namespace } from "vuex-class"

// @ts-ignore
import VuePerfectScrollbar from "vue-perfect-scrollbar"
import vSelect from "vue-select"

import SkeletonLoader from "@/components/SkeletonLoader.vue"
import DataTable from "../DataTable.vue"

import { Status } from "@/types"

import api from "@/services/api"
import apiStatus from "@/services/api_Status"

const caseStore = namespace("cases")

@Component({
	components: {
		"v-select": vSelect,
		"scrollbar": VuePerfectScrollbar,
		"data-table": DataTable,
		"skeleton": SkeletonLoader
	}
})
export default class StatusSetup extends Vue {
	$refs!: {
		dataTable: DataTable
	}

	@caseStore.Getter("getCases") public cases: any;
	@caseStore.Action public casesLoad!: () => void;
	@caseStore.Action public detailsLoad!: (refreshData: boolean) => void;

	private loading: boolean = false;
	private statuses: Status[] = [];

	private statusInUse: boolean = false;
	private statusReplacementListForDeletion: Status[] = [];
	private replacementStatus: any = null;

	public async mounted () {
		await this.loadStatuses()
	}

	private get columns (): any[] {
		return [
			{ key: "title", label: "Title", sortable: true, errors: (item: any) => (item.title !== "") ? null : "Please enter a title" },
			{ key: "default", label: "Default", sortable: false, dataType: "checkbox" }
		]
	}

	private async loadStatuses () {
		this.loading = true
		this.statuses = await apiStatus.statusList()
		this.loading = false
	}

	private createStatus () {
		return { id: null, title: "", default: false }
	}

	private async saveStatus (status: Status) {
		const currentStatus = this.statuses.find(s => s.id === status.id)
		const currentStatusWithDefault = this.statuses.find(s => s.default)

		// Add / update
		if (status.id === null || (currentStatus && currentStatus.title !== status.title)) {
			status.id = await apiStatus.statusSave(status)
		}

		// Default
		if (status.default && status.id) {
			if ((currentStatusWithDefault && currentStatusWithDefault.id !== status.id) || currentStatusWithDefault == null) {
				await apiStatus.statusDefault(status)
			}
		}

		this.loadStatuses()

		// Store
		this.loading = true
		const refreshData: boolean = true
		await this.detailsLoad(refreshData)
		this.loading = false
	}

	private async deleteStatus (status: Status) {
		if (!status.default && this.statuses.length > 1) {
			this.loading = true

			if (this.replacementStatus != null) {
				await api.replaceStatusOnCaseList(status.id, this.replacementStatus.id)
			}

			await apiStatus.statusDelete(status)

			await this.loadStatuses()

			// Store
			this.loading = true
			const refreshData: boolean = true
			await this.detailsLoad(refreshData)
			this.loading = false
		}
	}

	public async canDeleteStatus (status: Status): Promise<boolean> {
		this.replacementStatus = null
		this.statusReplacementListForDeletion = []

		this.statusInUse = await api.isStatusInUse(status.id!)
		this.$refs.dataTable.$refs.dataModal.deleteConfirmButtonDisabled = this.statusInUse

		this.statusReplacementListForDeletion = this.statuses.filter(s => s.id !== status.id)
		return !status.default && this.statuses.length > 1
	}

	private onDeletionStatusReplacementSelected () {
		this.$refs.dataTable.$refs.dataModal.deleteConfirmButtonDisabled = false
	}
}
